import React from 'react';

const NewUserRequestContext = React.createContext({});

export default NewUserRequestContext;
